module.exports = __webpack_public_path__ + "static/img/mjgy6b.d9911ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjgy6b.jpg
// module id = ViN7
// module chunks = 73